import script from "./UserAnswerQuestionMyList.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserAnswerQuestionMyList.vue?vue&type=script&setup=true&lang=ts"

import "./UserAnswerQuestionMyList.vue?vue&type=style&index=0&id=e75841f0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e75841f0"]])

export default __exports__